import React from "react";

export default function GitLink() {
  return (
    <div>
      <a href="https://github.com/znobakht/react" target="_blank" rel="noreferrer">
        {" "}
        GitHub
      </a>
    </div>
  );
}
